var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyCourier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1151 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745132 22.6384 0.745132 50.2484C0.745132 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74513 74.5084 6.74513 50.2484C6.74513 42.7784 8.61513 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5451 33.0284H26.0551C24.4151 33.0284 23.0751 34.3584 23.0751 36.0084V45.9884H38.5451V33.0284Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0551 61.8984H38.5451V48.9384H23.0751V58.9184C23.0751 60.5584 24.4051 61.8984 26.0551 61.8984Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9651 45.9884V36.0084C56.9651 34.3684 55.6351 33.0284 53.9851 33.0284H41.4951V45.9884H56.9651Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5051 61.8984H53.9951C55.6351 61.8984 56.9751 60.5684 56.9751 58.9184V48.9384H41.5151V61.8984H41.5051Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4251 30.2384C39.6151 30.3284 39.8251 30.3784 40.0251 30.3784C40.2251 30.3784 40.4351 30.3284 40.6251 30.2384C46.5651 27.3684 49.7051 23.2984 49.7051 18.4684C49.7051 15.4184 47.2251 12.9384 44.1751 12.9384C42.5251 12.9384 41.0451 13.6684 40.0251 14.8184C39.0151 13.6684 37.5251 12.9384 35.8751 12.9384C32.8251 12.9384 30.3451 15.4184 30.3451 18.4684C30.3451 23.2984 33.4851 27.3684 39.4251 30.2384ZM35.8751 15.6984C37.4051 15.6984 38.6451 16.9384 38.6451 18.4684C38.6451 19.2284 39.2651 19.8484 40.0251 19.8484C40.7851 19.8484 41.4051 19.2284 41.4051 18.4684C41.4051 16.9384 42.6451 15.6984 44.1751 15.6984C45.7051 15.6984 46.9451 16.9384 46.9451 18.4684C46.9451 22.0684 44.6151 25.0884 40.0251 27.4584C35.4351 25.0884 33.1051 22.0684 33.1051 18.4684C33.1051 16.9384 34.3451 15.6984 35.8751 15.6984Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7451 70.9384C66.3051 70.9384 63.5151 73.7384 63.5151 77.1684C63.5151 80.5984 66.3151 83.3984 69.7451 83.3984C73.1751 83.3984 75.9751 80.5984 75.9751 77.1684C75.9751 73.7384 73.1751 70.9384 69.7451 70.9384ZM69.7451 80.6384C67.8351 80.6384 66.2751 79.0784 66.2751 77.1684C66.2751 75.2584 67.8351 73.6984 69.7451 73.6984C71.6551 73.6984 73.2151 75.2584 73.2151 77.1684C73.2151 79.0784 71.6551 80.6384 69.7451 80.6384Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0551 70.9384C28.6151 70.9384 25.8251 73.7384 25.8251 77.1684C25.8251 80.5984 28.6251 83.3984 32.0551 83.3984C35.4851 83.3984 38.2851 80.5984 38.2851 77.1684C38.2851 73.7384 35.4851 70.9384 32.0551 70.9384ZM32.0551 80.6384C30.1451 80.6384 28.5851 79.0784 28.5851 77.1684C28.5851 75.2584 30.1451 73.6984 32.0551 73.6984C33.9651 73.6984 35.5251 75.2584 35.5251 77.1684C35.5251 79.0784 33.9651 80.6384 32.0551 80.6384Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0051 59.8484C82.0051 58.7484 81.5751 57.6884 80.7951 56.8984C78.1551 54.2184 76.2651 52.1784 73.6351 49.4984C72.8451 48.6984 71.7651 48.2384 70.6351 48.2384H64.9351C62.6151 48.2384 60.7251 50.1184 60.7251 52.4484V65.6584H21.2951C20.4551 65.6584 19.7851 66.3384 19.7851 67.1684V71.4784H19.7551C18.9151 71.4784 18.2451 72.1584 18.2451 72.9884V74.3884C18.2451 75.2284 18.9251 75.8984 19.7551 75.8984H23.1051C23.7151 71.5084 27.4951 68.1184 32.0551 68.1184C36.6151 68.1184 40.3851 71.5084 41.0051 75.8984H60.8051C61.4151 71.5084 65.1951 68.1184 69.7551 68.1184C74.3151 68.1184 78.0851 71.5084 78.7051 75.8984H82.0551C82.8951 75.8984 83.5651 75.2184 83.5651 74.3884V72.9884C83.5651 72.1484 82.8851 71.4784 82.0551 71.4784H82.0251V59.8484H82.0051ZM78.2451 61.8984H64.4951V52.4584C64.4951 52.2184 64.6951 52.0184 64.9351 52.0184H70.6351C70.7551 52.0184 70.8651 52.0684 70.9551 52.1484C72.2451 53.4584 73.3851 54.6484 74.4851 55.7884C75.6151 56.9584 76.7751 58.1784 78.1251 59.5384C78.2051 59.6184 78.2551 59.7284 78.2551 59.8484V61.8884L78.2451 61.8984Z",
    fill: "#FF4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1696",
    x: -0.00000339746,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1696",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1696"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1696",
    result: "effect3_innerShadow_4857_1696"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyCourier);
export default __webpack_public_path__ + "static/media/PropertyCourier.d223d85e28bd3ca282d9e205aaf142ba.svg";
export { ForwardRef as ReactComponent };